<template>
  <v-container fluid class="pa-2">
  
    <!-- Dashboard Title -->
    <v-row class="mb-3">
      <v-col cols="12">
        <h4 class="dashboard-title">Dashboard</h4>
      </v-col>
    </v-row>

    <!-- Properties Section -->
    <v-row dense>
      <v-col v-for="(property, index) in 1" :key="'property-' + index" cols="12" md="4">
        <GetProperties />
      </v-col>

      <!-- Tenants Section -->
      <v-col v-for="(tenant, index) in 1" :key="'tenant-' + index" cols="12" md="4">
        <GetTenants />
      </v-col>

      <!-- Leases Section -->
      <v-col v-for="(lease, index) in 1" :key="'lease-' + index" cols="12" md="4">
        <GetLeases />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GetProperties from "@/views/GetProperties.vue";
import GetTenants from "@/views/GetTenants.vue";
import GetLeases from "@/views/GetLeases.vue";

export default {
  components: {
    GetProperties,
    GetTenants,
    GetLeases,
  },
};
</script>

<style scoped>
.dashboard-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333333;
  margin: 0;
  letter-spacing: 0.3px;
}

/* Override any large text in child components */
:deep(.v-card) {
  font-size: 0.75rem !important;
}

:deep(.v-card .v-card-title) {
  font-size: 0.85rem !important;
  font-weight: 600 !important;
}

:deep(.v-card .v-card-subtitle) {
  font-size: 0.7rem !important;
}

:deep(.v-card .v-card-text) {
  font-size: 0.7rem !important;
}

:deep(.v-card .v-data-table) {
  font-size: 0.7rem !important;
}

:deep(.v-card .v-data-table th) {
  font-size: 0.6rem !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

:deep(.v-card .v-data-table td) {
  font-size: 0.7rem !important;
}

:deep(.v-card .v-btn) {
  font-size: 0.65rem !important;
  text-transform: none !important;
}

:deep(.v-card .v-chip) {
  font-size: 0.55rem !important;
  height: 20px !important;
}

:deep(.v-card .v-select) {
  font-size: 0.7rem !important;
}

:deep(.v-card .v-input) {
  font-size: 0.7rem !important;
}

:deep(.v-card .v-label) {
  font-size: 0.65rem !important;
}

:deep(.v-card .v-text-field input) {
  font-size: 0.7rem !important;
}

/* Compact spacing in cards */
:deep(.v-card) {
  border-radius: 8px !important;
}

:deep(.v-card .v-card-text) {
  padding: 12px !important;
}

:deep(.v-card .v-card-actions) {
  padding: 8px 12px !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dashboard-title {
    font-size: 1rem;
  }
  
  :deep(.v-card .v-card-title) {
    font-size: 0.75rem !important;
  }
  
  :deep(.v-card .v-card-text) {
    padding: 8px !important;
  }
}

@media (max-width: 600px) {
  .dashboard-title {
    font-size: 0.9rem;
  }
}
</style>